export default __webpack_public_path__ + "static/media/leggings_of_fiendish_invocation.c104d378.jpg";